export var ProductPreferences;
(function (ProductPreferences) {
    ProductPreferences["AbilityToAccessPrepaidFundsIfNeeded"] = "ABILITY_TO_ACCESS_PREPAID_FUNDS_IF_NEEDED";
    ProductPreferences["AbilityToPayOffLoanSooner"] = "ABILITY_TO_PAY_OFF_LOAN_SOONER";
    ProductPreferences["AccessFundsSameWayAsRegularBankAccount"] = "ACCESS_FUNDS_SAME_WAY_AS_A_REGULAR_BANK_ACCOUNT";
    ProductPreferences["HaveABalanceOfCertaintyOfRepaymentsAndFlexibility"] = "HAVE_A_BALANCE_OF_CERTAINTY_OF_REPAYMENTS_AND_FLEXIBILITY";
    ProductPreferences["HaveSetRepayments"] = "HAVE_SET_REPAYMENTS";
    ProductPreferences["TakeAdvantageOfInterestRateDrops"] = "TAKE_ADVANTAGE_OF_INTEREST_RATE_DROPS";
    ProductPreferences["UseSavingsOrSalaryToReduceInterest"] = "USE_SAVINGS_OR_SALARY_TO_REDUCE_INTEREST";
})(ProductPreferences || (ProductPreferences = {}));
//# sourceMappingURL=ProductPreferences.js.map